/**
 * 报表
 */

 import Layout from '@/layout/Layout.vue'

 export default {
  path: '/report',
  name: '报表',
  component: Layout,
  redirect: '/report/userStatistics',
  children: [
    {
      path: 'userStatistics',
      name: '用户统计',
      component: () => import('@/views/report/userStatistics/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'report_userStatistics'
      }
    },
    {
      path: 'userStatistcBy',
      name: '用户统计(运营)',
      component: () => import('@/views/report/userStatistcBy/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'report_userStatistcBy'
      }
    },
    {
      path: 'pageStatistics',
      name: '页面统计',
      component: () => import('@/views/report/pageStatistics/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'report_pageStatistics'
      }
    },
    {
      path: 'dynamicSales',
      name: '动销报表',
      component: () => import('@/views/report/dynamicSales/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'report_dynamicSales'
      }
    },
  ],
}